import React from "react";

const DeveloperWallet = () => {
  return (
    <div className="row-start-4 col-start-1 self-center text-center">
      <h3 className="text-4xl font-extrabold">Developer Wallet</h3>
      <p className="text-xl relative top-5">
        0x31F7F75D12248892202aC9CC32DA5dEFc5B09dC9
      </p>
    </div>
  );
};

export default DeveloperWallet;
